enum ApprovalStatusEnum {
    Approved = 'APPROVED',
    Draft = 'DRAFT',
    Quote = 'QUOTE',
    Rejected = 'REJECTED',
}

export default ApprovalStatusEnum;
